import React, { useState, useEffect, useRef } from "react";
import { BsCloudUpload } from "react-icons/bs";
import { FaTrash } from "react-icons/fa";
import axios from 'axios';
import toast from "react-hot-toast";

function Banner({ userData, token }) {
  const [banners, setBanners] = useState([]);
  const fileInputRef = useRef(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [currentBanner, setCurrentBanner] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("banner");
 const [userType, setUserType] = useState("");


  // setting
  const [commision, setCommision] = useState('');
  const [maxCoin, setMaxCoin] = useState('');
  const [fee, setFee] = useState('');
  const [minPurchase, setMinPurchase] = useState([]);
  const[enqFee,setEnqFee] = useState([]);
const[machineAmount,setMachineAmount] = useState([]);
const[freeQuotation,setFreeQuotation] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("userData"));

    const data = normalizeUser(userData || stored);

    if (data) {
      setCommision(data.gst_doc || "");
      setMaxCoin(data.aadhaar_front || "");//platform fee
      setFee(data.aadhaar_back || ""); //adv amt
      setMinPurchase(data.pan || "");
      setEnqFee(data.remark || "");
      setMachineAmount(data.bank_name || "");
      setFreeQuotation(data.acc_name || "");
    }
  }, [userData]);

  const storedUser = JSON.parse(localStorage.getItem("userData"));

  const normalizeUser = (data) => {
    if (!data) return null;

    if (data.result) return data.result;

    return data;
  };



  const handleSaveCoin = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.put(
        `https://api.krimotion.in/update-setting/${userData.id}`,
        { commision, maxCoin, fee, minPurchase , enqFee, machineAmount , freeQuotation },
        { 
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );



      const updated = res.data.result;

      const stored = JSON.parse(localStorage.getItem("userData"));

      const updatedUser = {
        ...stored,
        result: updated,
      };

      localStorage.setItem("userData", JSON.stringify(updatedUser));

      setCommision(updated.gst_doc);
      setMaxCoin(updated.aadhaar_front);
      setFee(updated.aadhaar_back);
      setMinPurchase(updated.pan)
      setEnqFee(updated.remark);
      setMachineAmount(updated.bank_name);
      setFreeQuotation(updated.freeQuotation);

      window.location.reload();

      toast.success("Updated successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update");
    }
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      toast.error("Only JPG and PNG images are allowed.");
      e.target.value = null;
      return;
    }

    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > 2) {
      toast.error("File size is too large! Please upload a file smaller than 2MB.");

      e.target.value = null;
      return;
    }
    setBannerFile(file);
  };



  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!bannerFile) {
  //     toast.error("Please select a banner image.");
  //     return;
  //   }

  //     if (!userType) {
  //   toast.error("Please select a user type.");
  //   return;
  // }

  //   try {
  //     const formData = new FormData();
  //     formData.append("image", bannerFile);

  //     const response = await axios.post(
  //       "https://api.krimotion.in/banner",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     toast.success('Banner uploaded successfully!');
  //     setBannerFile(null);
  //     fetchBanner();

  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = "";
  //     }

  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //     toast.error('Failed to upload banner.');
  //   }
  // };


  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!bannerFile) {
    toast.error("Please select a banner image.");
    return;
  }

  if (!userType) {
    toast.error("Please select a user type.");
    return;
  }

  try {
    const formData = new FormData();

    formData.append("image", bannerFile);
    formData.append("user_type", userType);

    const response = await axios.post(
      "https://api.krimotion.in/banner",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Banner uploaded successfully!");

    setBannerFile(null);
    setUserType("");

    fetchBanner();

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

  } catch (error) {
    console.error(error);
    toast.error("Failed to upload banner.");
  }
};



  useEffect(() => {
    fetchBanner();
  }, []);



  const fetchBanner = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/get-banner",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCurrentBanner(res.data);

    } catch (error) {
      console.error("Failed to fetch banner", error);
      setCurrentBanner([]);
    }
  };


  const handleRemoveBanner = async (bannerId) => {
    try {
      await axios.delete(`https://api.krimotion.in/delete-banner/${bannerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCurrentBanner(prev =>
        prev.filter(banner => banner.id !== bannerId)
      );
      toast.success("Banner deleted successfully!");
      fetchBanner();
    } catch (error) {
      console.error(error);
      toast.error("Failed to remove the banner");
    }
  };


  return (
    <div className="container py-4">

      <div className="d-flex mb-4 border-bottom pb-3">

        <button
          className={`btn me-2 ${activeTab === "banner"
              ? "btn-primary"
              : "btn-outline-primary"
            }`}
          onClick={() => setActiveTab("banner")}
        >
          Banner
        </button>

        <button
          className={`btn ${activeTab === "profile"
              ? "btn-primary"
              : "btn-outline-primary"
            }`}
          onClick={() => setActiveTab("profile")}
        >
          Setting
        </button>

      </div>

      {activeTab === "banner" && (
        <>
          <div className="card border-0 shadow rounded-4 p-4">

            <h3 className="fw-bold mb-4">Drag & Drop Upload</h3>


            <div
              className="border rounded-4 text-center p-5"
              style={{
                minHeight: "320px",
                borderStyle: "dashed",
                borderWidth: "2px",
                background: "#fafbff",
                cursor: "pointer",
              }}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();

                const file = e.dataTransfer.files[0];

                if (!file) return;

                setBannerFile(file);
              }}
            >
              <BsCloudUpload
                size={70}
                className="text-primary mb-3"
              />

              <h3 className="fw-normal">
                Drag and drop files here or click to browse
              </h3>

              <p className="text-muted fs-5">
                Maximum file size: 2MB
              </p>

              <label className="btn btn-outline-primary px-4 mt-2">
                Select Files
                <input
                  ref={fileInputRef}
                  type="file"
                  hidden
                  accept="image/png,image/jpeg"
                  onChange={handleFileChange}
                />
              </label>
              <div className="row"> 

            <div className="col-md-4"> </div>
            <div className="col-md-4 mt-3">
  <select
    className="form-select"
    value={userType}
    onChange={(e) => setUserType(e.target.value)}
  >
    <option value="">Select User Type</option>
    <option value="customer">Customer</option>
    <option value="dealer">Dealer</option>
    <option value="driver">Driver</option>
  </select>
</div>
  </div>


              {bannerFile && (
                <div className="mt-3">
                  <img
                    src={URL.createObjectURL(bannerFile)}
                    alt=""
                    className="img-fluid rounded"
                    style={{
                      height: "180px",
                      objectFit: "cover",
                    }}
                  />
                  <p className="mt-2">{bannerFile.name}</p>

                  <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                  >
                    Upload Banner
                  </button>
                </div>
              )}
            </div>

            {/* Preview */}
            {currentBanner.length > 0 && (
              <>
                <h4 className="fw-bold mt-5 mb-3">
                  Uploaded Banners
                </h4>

                <div
                  className="border rounded-4 p-3"
                  style={{
                    maxHeight: "420px",
                    overflowY: "auto",
                  }}
                >
                  <div className="row">
                    {currentBanner.map((banner, index) => (
                      <div className="col-md-6 mb-4" key={index}>

                       <div className="d-flex align-items-center gap-2 mb-2">
  <span className="fw-semibold">User Type:</span>

  <span className="badge rounded-pill bg-success px-2 py-2">
    {banner.user_type}
  </span>
</div>
                        <div className="card shadow-sm">

                          <img
                            src={`https://api.krimotion.in/uploads/${banner.banner}`}
                            alt=""
                            className="card-img-top"
                            style={{
                              height: "180px",
                              objectFit: "cover",
                            }}
                          />

                          <div className="card-body text-center">


                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleRemoveBanner(banner.id)}
                            >
                              <FaTrash className="me-2" />
                              Remove
                            </button>

                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}

          </div>
        </>
      )}

      {activeTab === "profile" && (
        <div className="card border-0 shadow-sm rounded-4 p-4">

          <h3 className="fw-bold mb-4">
            Settings
          </h3>

          <form onSubmit={handleSaveCoin}>

            <div className="row g-3">


{/* 
              <div className="col-md-4">
                <label className="form-label">
                  Set Commision Percentage
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={commision}
                  onChange={(e) => setCommision(e.target.value)}
                />
              </div> */}

              <div className="col-md-4">
                <label className="form-label">
                  Set Platform Fee
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={maxCoin}
                  onChange={(e) => setMaxCoin(e.target.value)}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">
                  Set Driver Advance Amount  </label>

                <input
                  type="text"
                  className="form-control"
                  value={fee}
                  onChange={(e) => setFee(e.target.value)}
                />
                (This amount is paid by customer to driver)
              </div>


              <div className="col-md-4">
                <label className="form-label">
                  Set Dealer Enquiry Purchase price
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={minPurchase}
                  onChange={(e) => setMinPurchase(e.target.value)}
                />
                (Set minimum purchasse price enquiry for dealer. )
              </div>


                 <div className="col-md-4">
                <label className="form-label">
                  Set Dealer Enquiry Fee
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={enqFee}
                  onChange={(e) => setEnqFee(e.target.value)}
                />
               (This is enquiry fee for dealer )
              </div>

                 <div className="col-md-4">
                <label className="form-label">
                  Customer Machine Advance Amount
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={machineAmount}
                  onChange={(e) => setMachineAmount(e.target.value)}
                />
                (Set advance machine amoount for customer.)
              </div>

                 <div className="col-md-4">
                <label className="form-label">
                Set Free Spare Enquiry For Dealer
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={freeQuotation}
                  onChange={(e) => setFreeQuotation(e.target.value)}
                />

                (Set free spare party enquiry for dealer.)
              </div>
            </div>
            <button
              className="btn btn-success text-end mt-2"
              type="submit"
            >
              Save Profile
            </button>


          </form>

        </div>
      )}


    </div>
  );
}

export default Banner;